// extracted by mini-css-extract-plugin
export default {"bottomNav":"BottomNav_bottomNav__-uZOb","navBtn":"BottomNav_navBtn__4CwvN","navBtnActive":"BottomNav_navBtnActive__vlPSr","navBtnLogout":"BottomNav_navBtnLogout__0mbKj"};